<template>
  <div class="objects-select-input clearfix">
    <div class="form-group">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 control-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <select class="form-control" multiple ref="dropdown"
          @change="validate()"
          :name="options.name+'[]'">
          <option v-for="object in options.objects" :value="object.uuid">{{ object[options.objectName] }}</option>
        </select>
          <span :class="validationClass" v-show="validationMessage">
            {{ validationMessage }}
          </span>
          <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Choices from 'choices.js'
import {
  validationClass,
  validationIcon,
  validationMessage,
  randomLabel
} from '@/util/helpers'

export default {
  name: 'ObjectsSelectInput',
  props: {
    value: {
      type: [Array, String]
    },
    options: {
      type: Object,
      default () {
        return {
          label: 'Text',
          name: 'objectsSelect',
          allowNew: false,
          objectName: 'name',
          value: [],
          objects: []
        }
      }
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      return this.options.label + ' is required'
    }
  },
  data () {
    return {
      isDirty: false,
      isValid: false,
      choices: null
    }
  },
  mounted () {
    let options = this.options
    function callbackOnCreateTemplates (template) {
      let classNames = this.config.classNames
      return {
        item: (data) => {
          let object = options.objects[data.choiceId - 1]
          let label = data.label
          let closeButton = `
          <button class="${classNames.button}" data-button>Remove item</button>
          `
          if (data.id && object) {
            if (object[options.iconName]) {
              label = `<span class="fa fa-fw ${object[options.iconName]}"></span> ${data.label}`
            }
          }
          if (data.title) {
            label = `${data.label}  ${data.title}`
          }
          if (options.labelName) {
            let labelText = object[options.labelName]
            let classNames = randomLabel(labelText)
            let className = 'label-default'
            for (let labelClass in classNames) {
              if (classNames[labelClass]) className = labelClass
            }
            label = `${label}&nbsp;&nbsp;<span class="label ${className}">${labelText}</span>`
          }
          if (this.config.removeItemButton) {
            label = `${label} ${closeButton}`
          }
          return template(`
          <div class="${classNames.item} ${data.highlighted ? classNames.highlightedState : classNames.itemSelectable}"  data-item data-id="${data.id}" data-value="${data.value}" ${data.active ? 'aria-selected="true"' : ''} ${data.disabled ? 'aria-disabled="true"' : ''}>${label}</div>
          `)
        },
        choice: (data) => {
          let object = options.objects[data.id - 1]
          let label = data.label
          if (data.id && object) {
            if (object[options.iconName]) {
              label = `<span class="fa fa-fw ${object[options.iconName]}"></span> ${data.label}`
            }
          }
          let coloredLabel = ''
          if (options.labelName) {
            let labelText = object[options.labelName]
            let classNames = randomLabel(labelText)
            let className = 'label-default'
            for (let labelClass in classNames) {
              if (classNames[labelClass]) className = labelClass
            }
            coloredLabel = `&nbsp;&nbsp;<span class="label ${className}">${labelText}</span>`
          }
          return template(`
          <div class="${classNames.item} ${classNames.itemChoice} ${data.disabled ? classNames.itemDisabled : classNames.itemSelectable} ${data.disabled ? classNames.itemDisabled : classNames.itemSelectable}" data-select-text="${this.config.itemSelectText}" data-choice ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'} data-id="${data.id}" data-value="${data.value}" ${data.groupId > 0 ? 'role="treeitem"' : 'role="option"'}>${label}${coloredLabel}</div>
          `)
        }
      }
    }
    let $vm = this
    this.choices = new Choices(this.$refs.dropdown, {
      callbackOnCreateTemplates,
      itemSelectText: '',
      removeItemButton: true,
      searchFields: ['label'],
      fuseOptions: {
        threshold: 0.1
      },
      callbackOnInit: function () {
        if (!$vm.value) {
          let value = this.store.getItemsFilteredByActive().pop().value
          this.removeItemsByValue(value)
        } else {
          this.setValueByChoice($vm.value)
        }
      }
    })
  },
  watch: {
    'options.objects': function (oldVal, newVal) {
      this.updateChoices()
    }
  },
  methods: {
    async updateChoices () {
      if (this.choices) {
        // updates the choices input with new values
        this.choices.clearInput()
        this.choices.config.searchPlaceholderValue = 'Select a ' + this.options.label
        this.choices.config.placeholderValue = 'Select a ' + this.options.label
        if (this.choices.containerInner.children[1].children[0]) {
          this.choices.containerInner.children[1].children[0].innerHTML = ''
        }
        this.choices.containerOuter.children[1].children[0].placeholder = 'Select a ' + this.options.label
        this.choices.setChoices(this.options.objects, 'uuid', this.options.objectName, true)
        await this.$nextTick()
        if (this.value) {
          // let val = this.choices.getValue(true)
          this.choices.removeHighlightedItems()
          this.choices.removeActiveItems()
          this.choices.setValueByChoice(this.value)
        }
      }
    },
    async validate () {
      await this.$nextTick()
      let val = this.choices.getValue(true)
      this.$emit('input', val)
      if (val.length > 0) {
        this.isDirty = true
        if (this.options.required) {
          this.isValid = val ? val.length > 0 : true
        } else {
          this.isValid = true
        }
      } else if (this.options.required) {
        this.isDirty = true
        this.isValid = false
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/ObjectsSelectInput.vue